import { routes as List } from './list/index'
import { routes as ShowEmployee } from './show/index'
import { routes as EmployeePaycheck } from './paycheck/index'
import { routes as ScaleList } from './scales/index'

export default [
  {
    path: '/users',
    name: 'employees',
    component: () => import('./Users.vue'),
    children: [...List, ...ShowEmployee, ...EmployeePaycheck, ...ScaleList],
    meta: {
      name: 'Funcionários',
      auth: true,
      user: 'Admin',
    },
  },
]
